let cookieValue = document.cookie.match('(^|;) ?' + 'wishlist' + '=([^;]*)(;|$)');
let wishlistArray = cookieValue ? JSON.parse(cookieValue[2]) : [];
const allWishButtons = Array.from(document.querySelectorAll('.wishlist-Product'));
const allWishHeadLink = document.querySelectorAll('.wishlist_link');
if (wishlistArray.length) {
  allWishHeadLink?.forEach(link =>{
    link.classList.add('active');
    link.querySelector('.wishlist-bubble').classList.remove('hidden');
    link.querySelector('.wishlist-bubble').innerText = wishlistArray.length;
  });
}
const onButtonClick = (button) => {
  if (button.classList.contains('active')){
    button.classList.remove('active');
  } else {
    button.classList.add('active');
  }
  let newArray = {};
  if (!wishlistArray.find(obj => obj.var === button.dataset.var)){
    newArray.id = button.dataset.id;
    newArray.title = button.dataset.title;
    newArray.handle = button.dataset.handle;
    newArray.var = button.dataset.var;
    wishlistArray.push(newArray);
  } else {
    wishlistArray = wishlistArray.filter(obj => obj.var!== button.dataset.var);
  }
  
  let arrayString = JSON.stringify(wishlistArray);
  let expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);
  document.cookie = `wishlist=${arrayString}; expires=${expirationDate.toUTCString()}; path=/`;
  if (wishlistArray.length) {
    allWishHeadLink?.forEach(link =>{
      link.classList.add('active');
      link.querySelector('.wishlist-bubble').classList.remove('hidden');
      link.querySelector('.wishlist-bubble').innerText = wishlistArray.length;
    });
  } else {
    allWishHeadLink?.forEach(link =>{
      link.classList.remove('active')
      link.querySelector('.wishlist-bubble').classList.add('hidden');
      link.querySelector('.wishlist-bubble').innerText = '';
    });
  }
}

allWishButtons?.forEach(button =>{
  if (wishlistArray.find(obj => obj.var === button.dataset.var)){
    button.classList.add('active');
  }
  button.addEventListener('click', (e)=>{
    onButtonClick(button)
  })
});